import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { MUTATION_TYPE, useToast } from "hooks";
import { css } from "@emotion/react";
import { UPDATE_APPLICANT } from "graphql/mutations";
import { MODAL_SIZE, ModalForm } from "components/Modal";
import { REQUIREMENTS_FORM_FIELD } from "components/Missions/Roles";

/**
 * ApplicationRequirementsForm
 *
 * @param {Object}    missionRoleApplicant
 * @param {Array}     requirements
 * @param {Object}    initialValues
 * @param {Boolean}   show
 * @param {Function}  onClose
 */
const ApplicationRequirementsForm = ({
  missionRoleApplicant,
  requirements,
  initialValues,
  show,
  onClose,
  ...props
}) => {
  const { toast } = useToast();

  const handleComplete = () => toast.success(<FormattedMessage id="MissionRoleApplicant.Update.Toast.Success" />);

  return (
    <ModalForm
      title={<FormattedMessage id="Missions.Applicants.ApplicationRequirementsForm.ModalForm.Title" />}
      data={FORM_DATA(requirements)}
      onCompleted={handleComplete}
      initialValues={initialValues}
      updateId={missionRoleApplicant.id}
      mutationType={MUTATION_TYPE.update}
      mutationData={{
        mutationName: {
          update: UPDATE_APPLICANT,
        },
      }}
      size={MODAL_SIZE.large}
      show={show}
      onClose={onClose}
      {...props}
    />
  );
};

const FORM_DATA = (requirements) => [
  {
    style: css`
      width: 100%;
    `,
    items: [REQUIREMENTS_FORM_FIELD(requirements)],
  },
];

ApplicationRequirementsForm.propTypes = {
  missionRoleApplicant: PropTypes.object.isRequired,
  requirements: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      isComplete: PropTypes.bool.isRequired,
    })
  ).isRequired,
  initialValues: PropTypes.object,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ApplicationRequirementsForm;
